<script>
    export default {
        data() {
            return {
                errorText: '',
            }
        },
        computed: {
            addData() {return this.$store.getters.USER_ADD_DATA}
        },
        methods: {
            async changeName(event) {
                this.$store.commit('USER_ADD_DATA', {name: event.target.value});
                this.errorText = await this.$store.dispatch('CHECK_USER_ADD');
            },
            async changePassword(event) {
                this.$store.commit('USER_ADD_DATA', {password: event.target.value});
                this.errorText = await this.$store.dispatch('CHECK_USER_ADD');
            },
            async changeEmail(event) {
                this.$store.commit('USER_ADD_DATA', {email: event.target.value});
                this.errorText = await this.$store.dispatch('CHECK_USER_ADD');
            },
            async changeCompany(event) {
                this.$store.commit('USER_ADD_DATA', {company: event.target.value});
                this.errorText = await this.$store.dispatch('CHECK_USER_ADD');
            },
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name:</label>
        <input
            v-model="addData['name']"
            @change="changeName"
            class="right_input mt_5 mb_10" 
            type="text"
        >
        <label>Password:</label>
        <input
            v-model="addData['password']"
            @change="changePassword"
            class="right_input mt_5 mb_10" 
            type="text"
        >
        <label>Email:</label>
        <input 
            v-model="addData['email']"
            @change="changeEmail"
            class="right_input mt_5 mb_10"
            type="email"    
        >
        <label>Company:</label>
        <input
            v-model="addData['company']"
            @change="changeCompany"
            class="right_input mt_5 mb_10"
            type="text"
        >

        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>
</template>